import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AdminRoute } from './components/AdminRoute';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './contexts/auth-context';
import { AdminPage } from './pages/AdminPage';
import { DashboardPage } from './pages/DashboardPage';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { ModPage } from './pages/ModPage';
import { ObsPluginPage } from './pages/ObsPluginPage';
import { OverlayPage } from './pages/OverlayPage';
import { RegisterPage } from './pages/RegisterPage';
import { SendMessagePage } from './pages/SendMessagePage';

/**
 * Rotas da aplicação:
 *
 *   /                → landing (apresentação + links de login/cadastro)
 *   /login           → login do criador
 *   /cadastro        → cadastro do criador
 *   /dashboard       → dashboard do criador (PROTEGIDA: exige login)
 *   /admin           → painel de administração (PROTEGIDA: exige conta admin)
 *   /overlay/:token  → overlay TRANSPARENTE carregado dentro do OBS
 *   /mod/:token      → página do MODERADOR (tempo real, sem OBS)
 *   /obs             → página pública de download/instalação do plugin OBS
 *   /:username       → página PÚBLICA de envio de mensagem de um criador
 *                      (fica por último para não engolir as rotas acima;
 *                      usernames de rotas são RESERVADOS no cadastro)
 */
export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/cadastro" element={<RegisterPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            }
          />
          <Route path="/overlay/:token" element={<OverlayPage />} />
          <Route path="/mod/:token" element={<ModPage />} />
          <Route path="/obs" element={<ObsPluginPage />} />
          <Route path="/:username" element={<SendMessagePage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
